import { useState } from "react";
import { Button, FormControl, InputLabel } from "@mui/material";
import PropTypes from "prop-types";

import vehicleClass from "../vehicle/vehicleClass";
import GridVehicleSelectorDialog from "./GridVehicleSelectorDialog";
import { DropdownIcon } from "../icons/ArrowIcons";
import { useGridData } from "src/context/GridContext/GridContext";

export default function GridVehicleSelectorDropDown({
  vehicle,
  setVehicle,
  disabled = false,
  fontSize = "1.2rem",
  height = "40px",
}) {
  const { vehicles, time } = useGridData();
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState(vehicle);

  const vehicleText = vehicle ? vehicleClass.vehicleText(vehicle) : "Valitse ajoneuvo";

  const handleOpen = () => {
    if (disabled) return;
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleSelect = (vehicle) => {
    setSelected(vehicle);
    setVehicle(vehicle);
    handleClose();
  };

  return (
    <div style={{ width: "100%" }}>
      <GridVehicleSelectorDialog
        open={open}
        onClose={handleClose}
        onSelect={handleSelect}
        selectedVehicle={selected}
        vehiclesProp={vehicles}
        time={time}
      />
      <div className="flexCol4" style={{ position: "relative" }}>
        <FormControl>
          <InputLabel shrink>Ajoneuvo</InputLabel>
          <Button
            size="small"
            variant="outlined"
            onClick={handleOpen}
            label="jhkjhk"
            fullWidth
            sx={{ height: height }}>
            <div className="spaceBetween" style={{ fontSize: fontSize }}>
              {vehicleText}
              {!disabled && <DropdownIcon />}
            </div>
          </Button>
        </FormControl>
      </div>
    </div>
  );
}

GridVehicleSelectorDropDown.propTypes = {
  vehicle: PropTypes.object,
  setVehicle: PropTypes.func.isRequired,
  cnt: PropTypes.number,
  hideInputLabel: PropTypes.bool,
  disabled: PropTypes.bool,
  fontSize: PropTypes.string,
  height: PropTypes.string,
};
